import { useState } from 'react'
import Button from '@mui/material/Button'
import AlertModal from './AlertModal/index'
import CustomModal from './CustomModal/CustomModal'
import FullScreenDialog from './FullScreenDialog/FullScreenDialog'
import { Box, Grid, Typography } from '@mui/material'

const ModalPanel: React.FC = () => {
  const [modalType, setModalType] = useState<'alert' | 'custom' | 'fullscreen' | null>(null)
  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = (type: 'alert' | 'custom' | 'fullscreen') => {
    setModalType(type)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setModalType(null)
  }

  const handleConfirm = () => {
    // handle confirmation logic
    handleClose()
  }

  return (
    <Box>
      <h2>Modals</h2>
      <Grid container spacing={2}>
        <Grid>
          <Button color='error' onClick={() => handleOpen('alert')}>
            Open Alert Modal
          </Button>
        </Grid>
        <Grid>
          <Button onClick={() => handleOpen('custom')}>Open Custom Modal</Button>
        </Grid>
        <Grid>
          <Button color='success' onClick={() => handleOpen('fullscreen')}>
            Open Fullscreen Modal
          </Button>
        </Grid>
      </Grid>

      {modalType === 'alert' && (
        <AlertModal
          open={open}
          onClose={handleClose}
          title='Alert Modal Title'
          description='This is the description for the alert modal.'
          actionButton={
            <>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={handleConfirm} autoFocus>
                Confirm
              </Button>
            </>
          }
        />
      )}

      {modalType === 'custom' && (
        <CustomModal
          open={open}
          onClose={handleClose}
          title='Custom Modal Title'
          bodyContent={
            <div>
              <Typography gutterBottom>
                Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis
                in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
              </Typography>
              <Typography gutterBottom>
                Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis
                lacus vel augue laoreet rutrum faucibus dolor auctor.
              </Typography>
              <Typography gutterBottom>
                Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel
                scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus
                auctor fringilla.
              </Typography>
            </div>
          }
          footerContent={<Button onClick={handleClose}>Cancel</Button>}
          size='medium'
        />
      )}

      {modalType === 'fullscreen' && (
        <FullScreenDialog
          show={open}
          onHide={handleClose}
          ariaLabelBy='fullscreen-dialog-title'
          hasCloseBtn
          customHeaderStyle={{ backgroundColor: '#f5f5f5' }}
          headerContent={<div>Fullscreen Header Content</div>}
          customBodyStyle={{ padding: '20px' }}
          bodyContent={<div>This is the body label of the fullscreen dialog.</div>}
        />
      )}
    </Box>
  )
}

export default ModalPanel
